import "core-js/modules/es.array.sort";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.max-safe-integer";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LocationDeriver =
/*#__PURE__*/
function () {
  function LocationDeriver() {
    _classCallCheck(this, LocationDeriver);
  }

  _createClass(LocationDeriver, null, [{
    key: "groupByParent",
    value: function groupByParent(locations) {
      return locations.reduce(function (result, location) {
        if (result[location.parent_id]) {
          result[location.parent_id].children.push(location);
        } else {
          result[location.parent_id] = {
            id: location.parent_id,
            name: location.parent_name,
            position: location.parent_position !== undefined ? location.parent_position : Number.MAX_SAFE_INTEGER,
            children: [location]
          };
        }

        return result;
      }, []).sort(function (a, b) {
        return a.position > b.position;
      });
    }
  }, {
    key: "addressRequirements",
    value: function addressRequirements(data) {
      return {
        address1: data.address_fields.address_line_1,
        address2: data.address_fields.address_line_2,
        city: data.address_fields.city,
        postalCode: data.address_fields.postal_code,
        state: data.address_fields.state_code
      };
    }
  }]);

  return LocationDeriver;
}();

export { LocationDeriver as default };